import { render } from "./EditReview.vue?vue&type=template&id=a495c1e2&scoped=true"
import script from "./EditReview.vue?vue&type=script&lang=js"
export * from "./EditReview.vue?vue&type=script&lang=js"

import "./review.scss?vue&type=style&index=0&id=a495c1e2&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a495c1e2"]])

export default __exports__